import { render, staticRenderFns } from "./GeoAnalisysComponent.vue?vue&type=template&id=aa2b4f28&"
import script from "./GeoAnalisysComponent.vue?vue&type=script&lang=js&"
export * from "./GeoAnalisysComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports